import { gql } from '@apollo/client';

export const AuditTrailQuery = gql`
  query fetchAuditTrailForEntitlement(
    $id: String
    $searchOptions: ConnectionSearchOptions
    $dateFilter: DateRange
    $filterOptions: [FilterOption]
  ) {
    entitlementDetails(id: $id) {
      id
      auditNotes(searchOptions: $searchOptions, dateFilter: $dateFilter, filterOptions: $filterOptions) {
        totalCount
        nodes {
          body
          author
          created
          contactKey
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
